<template>
<div
    v-if="profile != null"
>

    <v-text-field
        label="Name (internal only)"
        v-model="profile.form.internal_label"
        v-on:input="put"
    />

    <m-edit-text
        label="Public URL"
        :value="public_url"
        read_only
    />

    <div
        style="text-align: right"
    >
        <v-btn
            v-on:click="onClickExport"
            style="margin-right: 15px"
        >
            Excel Export Form Submissions...
        </v-btn>

        <v-btn
            v-on:click="onClickQRCode"
        >
            QR Code...
        </v-btn>
    </div>

    <m-qr-code-dialog
        ref="qr-code-dialog"
    />



    <v-checkbox
        v-model="profile.form.is_archived"
        v-on:change="doPut"
        label="Archived"
        style="margin-top: -10px"
    />

     <m-edit-date
        label="Auto Archive Form on or After (Date)"
        v-model="profile.form.auto_archive_date"
        v-on:input="doPut"
        hint="This form will be automatically archived on or after this date (may be delayed up to 3 hours)"
        style="margin-bottom: 15px"
    />

    <v-select
        label="Banner Branding"
        v-model="profile.form.banner_id"
        :items="profile.banner_branding_choices"
        v-on:change="doPut"
    />

    <v-select
        label="When complete, submit contact request to inbox"
        v-model="profile.form.submit_to_inbox_id"
        :items="profile.inboxes"
        v-on:change="doPut"
    />

    <v-select
        label="When complete, add contact to list(s)"
        v-model="profile.form.add_to_lists"
        :items="profile.lists"
        v-on:change="doPut"
        multiple
        chips
    />

    <v-text-field
        label="Title"
        v-model="profile.form.title"
        v-on:input="put"
    />

    <v-textarea
        label="Instructions"
        v-model="profile.form.md_instructions"
        v-on:input="put"
        :rows="1"
        auto-grow
    />

    <v-switch
        label="After submit, redirect to custom url"
        v-model="profile.form.after_submit_redirect_to_custom_url"
        v-on:change="doPut"
        style="margin-top: 0px; margin-bottom: 0px"
    />

    <v-text-field
        label="After submit, redirect to the following url"
        v-model="profile.form.after_submit_redirect_url"
        v-on:input="put"
        v-show="profile.form.after_submit_redirect_to_custom_url"
    />

   <v-text-field
        label="After Submit Title"
        v-model="profile.form.after_submit_title"
        v-on:input="put"
        v-show="!profile.form.after_submit_redirect_to_custom_url"
    />




    <a
        v-on:click="onClickPreviewAfterSubmitUrl()"
        v-show="profile.form.after_submit_redirect_to_custom_url"
    >
        Open after submit url in a new tab
    </a>

    <v-textarea
        label="After Submit Instructions"
        v-model="profile.form.md_after_submit_instructions"
        v-on:input="put"
        :rows="1"
        auto-grow
        v-show="!profile.form.after_submit_redirect_to_custom_url"
    />

    <v-switch
        label="For testing: show after submit"
        v-on:change="$emit('toggle-show-after-submit')"
        style="margin-top: -15px; margin-bottom: 15px"
        v-show="!profile.form.after_submit_redirect_to_custom_url"
    />



    <m-custom-form-field-editor
        v-for="(item, index) in profile.fields"
        :key="index"
        :field="item"
        :field_count="profile.fields.length"
        v-on:move-up="onMoveUp"
        v-on:move-down="onMoveDown"
        v-on:change="$emit('change')"
        v-on:delete="onDeleteField"
        :other_fields="withoutField(index)"
        :profile="profile"
    >
    </m-custom-form-field-editor>

    <div
        style="text-align: right; margin-bottom: 30px;"
    >
        <v-btn
            v-on:click="onClickAddField"
        >
            Add Field
        </v-btn>
    </div>
    <div
        v-if="robust_age_gate && !has_payment_field"
        style="margin-bottom: 30px;"
    >

        <v-alert
            border="left"
            colored-border
            color="info"
            elevation="2"
            type="info"
            style="margin-bottom: 15px;"
        >
            This form requires age verification because your organization is in the wine industry.
            You can customize the minimum age requirement below.
        </v-alert>

        <m-edit-text
            label="Minimum Age (years)"
            :value="age_gate_display_value"
            v-on:input="onAgeGateInput"
            integer_positive_non_zero
            :hint="age_gate_hint"
            persistent-hint
        />
    </div>
    <v-switch
        label="Use double opt-in"
        v-on:change="put"
        v-model="profile.form.double_opt_in"
    />

    <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      v-if="has_payment_field && profile.form.double_opt_in"
    >
        <b>WARNING</b> We <b>STRONGLY RECOMMEND</b> that you <b>DO NOT</b> use double opt in on a form that involves a payment.<br/><br/>
        Why?<br/><br/>
        Because, unless and untill the customer completes the double opt in process you will not be able to see the form submission or payment information.  This means, for example, that if you were using a form to purchase (say) an event ticket and select double opt-in a customer may believe they have completed their purchase, not be wanting to opt and and <b>you will never know that this customer sumitted everything</b><br/><br/>
        Bottom Line: <b>DO NOT USE DOUBLE OPT IN WITH PAYMENT FORMS</b>
    </v-alert>

    <m-edit-select-organization-owned-endpoint
        :organization_id="profile.form.organization_id"
        v-model="profile.form.double_opt_in_send_from"
        v-on:input="put"
        label="Send double opt-in message from"
        v-show="profile.form.double_opt_in"
    />

    <v-select
        label="Double Opt-In Message Type"
        v-model="profile.form.double_opt_in_message_type"
        :items="$rc.enumChoices('double_opt_in_message_type', false)"
        v-on:input="onPutDoubleOptInMessageType"
        v-show="profile.form.double_opt_in"
    />

    <m-edit-message-patterns-compact
        v-if="profile.form.double_opt_in && profile.form.double_opt_in_message_type == 'custom'"
        style="margin-bottom: 30px;"
        label="Custom Double Opt-In Message"
        v-model="double_opt_in_message_patterns"
        context="double-opt-in"
        v-on:input="onUpdateDoubleOptInMessagePatterns"
    />

    <div
        style="text-align: right"
        v-if="profile.form.double_opt_in && profile.form.double_opt_in_message_type == 'custom'"
    >
        <v-btn
            v-on:click="onClickReturnToDefaultDoubleOptInMessage"
        >
            Return to Default Double Opt-In Message
        </v-btn>
    </div>

     <p
        v-if="profile.form.double_opt_in && profile.form.double_opt_in_message_type == 'default-message'"
    >
        <b>Double Opt-In Message Pattern (Default):  </b> {{profile.double_opt_in_pattern}}
    </p>

     <v-switch
        :label="profile.form.double_opt_in ? 'After double opt-in complete, send message' : 'After form submission, send message'"
        v-on:change="put"
        v-model="profile.form.after_submit_auto_message_enabled"
    />

    <m-edit-select-organization-owned-endpoint
        :organization_id="profile.form.organization_id"
        v-model="profile.form.after_submit_auto_message_send_from"
        v-on:input="put"
        label="Send message from"
    />

    <m-edit-message-patterns-compact
        style="margin-bottom: 30px;"
        label="Message to automatically send after form submission"
        v-model="profile.form.after_submit_auto_message_patterns"
        context="form-after-submit"
        v-on:input="put"
    />

    <m-edit-blobs
        label="Image to send with message after form submission (optional)"
        empty_text="No image"
        v-model="profile.form.after_submit_auto_message_blob_ids"
        v-on:input="put"
        :process_media="true"
        :externally_visible="true"
        :allow_multiple="false"
        :limit_to_size="460800"
        style="padding-bottom: 7px; margin-bottom: 15px; border-bottom: 1px solid rgb(148,148,148); margin-top: 15px"
        edit_icon="mdi-lead-pencil"
        dialog_title="Select Image"
        dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
    />

    <m-select-vcard
        label="Contact card to send with message after form submission (optional)"
        v-model="profile.form.after_submit_auto_message_vcard_id"
        v-on:input="put"
        ref="select-contact-card"
        style="margin-top: 15px"
    />



    <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      v-if="!profile.can_edit_consent_agreement"
    >
        RedChirp staff members can not edit consent agreement (must be edited by a user of the organization)
    </v-alert>

    <v-select
        label="Consent Agreement Type"
        v-model="profile.form.consent_agreement_type"
        :items="$rc.enumChoices('consent_agreement_type', false)"
        v-on:input="onPutConsentAgreementType"
        :disabled="!profile.can_edit_consent_agreement"
    />

    <m-edit-message-patterns-compact
        v-if="profile.form.consent_agreement_type == 'custom'"
        style="margin-bottom: 30px;"
        label="Consent Agreement"
        v-model="profile.form.consent_agreement_custom_patterns"
        context="consent-agreement"
        v-on:input="put"
        :disabled="!profile.can_edit_consent_agreement"
    />

    <div
        style="text-align: right"
        v-if="profile.form.consent_agreement_type == 'custom'"
    >
        <v-btn
            v-on:click="onClickReturnToDefaultConsentAgreement"
        >
            Return to Default Consent Agreement
        </v-btn>
    </div>

</div>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            profile: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/forms/profile/:form_id',

                'params' : {
                        'form_id': this.$route.params.form_id,
                    },

                'on_success': (data) => {
                        this.profile = data;
                        this.$emit('title',this.profile.organization_account.label+": "+this.profile.form.internal_label);
                    },

                'on_error': 'Unable to open form profile',
            });
        },

        put: _.debounce(function(){
            this.doPut();
        }, 751),

        doPut()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/forms',

                'params' : this.profile.form,

                'on_success': (data) => {
                        this.$emit('change');
                        this.$emit('title',this.profile.organization_account.label+": "+this.profile.form.internal_label);
                    },

                'on_error': 'Unable to save form',
            });
        },

        onPutConsentAgreementType()
        {
            if ( this.profile.form.consent_agreement_type == 'custom' && (this.profile.form.consent_agreement_custom_patterns ?? []).length == 0 )
            {
                this.profile.form.consent_agreement_custom_patterns = this.profile.default_consent_agreement_patterns;
            }

            this.doPut();
        },

        onAgeGateInput(value)
        {
            // Convert string input to integer, or null if empty
            if ( value === '' || value == null )
            {
                this.profile.form.age_gate_min_age_in_years = null;
            }
            else
            {
                const intValue = parseInt(value, 10);
                if ( !isNaN(intValue) && intValue > 0 )
                {
                    this.profile.form.age_gate_min_age_in_years = intValue;
                }
            }
            this.put();
        },

        onPutDoubleOptInMessageType()
        {
            // Handle message type changes in the frontend
            if (this.profile.form.double_opt_in_message_type === 'custom') {
                // If no custom message exists, initialize with the default pattern
                if (!this.profile.form.double_opt_in_message) {
                    this.profile.form.double_opt_in_message = this.profile.double_opt_in_pattern;
                }
            } else if (this.profile.form.double_opt_in_message_type === 'default-message') {
                // Clear the custom message when switching to default type
                this.profile.form.double_opt_in_message = null;
            }

            this.doPut();
        },

        onUpdateDoubleOptInMessagePatterns(patterns)
        {
            // Update the double_opt_in_message with the first pattern
            if (patterns && patterns.length > 0) {
                this.profile.form.double_opt_in_message = patterns[0];
            } else {
                this.profile.form.double_opt_in_message = null;
            }

            this.put();
        },

        onClickReturnToDefaultDoubleOptInMessage()
        {
            this.$rc.confirm({
                'title': 'Confirm Return to Default Double Opt-In Message',
                'body': 'Confirm that you wish to use the default double opt-in message?',
                'btn_text_ok': 'Return to Default',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doReturnToDefaultDoubleOptInMessage();
                },
            });
        },

        doReturnToDefaultDoubleOptInMessage()
        {
            this.profile.form.double_opt_in_message_type = 'default-message';
            this.profile.form.double_opt_in_message = null;
            this.doPut();
        },

        onClickReturnToDefaultConsentAgreement()
        {
            this.$rc.confirm({
                'title': 'Confirm Return to Default Consent Agreement',
                'body': 'Confirm that you wish to use the default consent agreement?',
                'btn_text_ok': 'Return to Default',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doReturnToDefaultConsentAgreement();
                },
            });
        },

        doReturnToDefaultConsentAgreement()
        {
            this.profile.form.consent_agreement_custom_patterns = this.profile.default_consent_agreement_patterns;
            this.doPut();
        },

        onClickAddField()
        {
           this.$rc.rest({
            'spinner': false,
            'endpoint': 'PUT: /api/v1/forms/add-new-custom-field',

            'params' : {
                    'form_id': this.$route.params.form_id,
                },

            'on_success': (data) => {
                    this.update();
                    this.$emit('change');
                },

            'on_error': 'Unable to add new field to form.',
           });
        },

        onMoveUp(field)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/forms/custom-field/move-up',

                'params' : {
                        'form_field_id': field.form_field_id,
                    },

                'on_success': (data) => {
                        this.update();
                        this.$emit('change');
                    },

                'on_error': 'Unable to move field',
            });
        },

        onMoveDown(field)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/forms/custom-field/move-down',

                'params' : {
                        'form_field_id': field.form_field_id,
                    },

                'on_success': (data) => {
                        this.update();
                        this.$emit('change');
                    },

                'on_error': 'Unable to move field',
            });
        },

        onDeleteField()
        {
            this.update();
            this.$emit('change');
        },

        onClickQRCode()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/forms/generate-qr-code',

                'params' : {
                        'form_id': this.$route.params.form_id,
                    },

                'on_success': (data) => {
                        this.$refs['qr-code-dialog'].showDialog(data.qr_code_id);
                    },

                'on_error': 'Unable to create QR code',
            });
        },

        onClickExport()
        {
            let form_id = this.$route.params.form_id;

            this.$rc.excelExport(
                    'EXPORT: /api/v1/search-contact-requests/:in_organization_id',
                    {
                        'in_organization_id' : this.profile.organization_account.organization_id,
                        'organization_id' : this.profile.organization_account.organization_id,

                        'form_id': form_id
                    }
                );
        },

        withoutField(index)
        {
            let ret = [];

            if ( this.profile == null || this.profile.fields == null )
                return ret;

            for ( let i = 0; i < this.profile.fields.length; i++ )
            {
                if ( i == index ) continue;
                ret.push(_.cloneDeep(this.profile.fields[i]));
            }

            return ret;
        },

        onClickPreviewAfterSubmitUrl()
        {
            window.open(this.profile.form.after_submit_redirect_url,'_blank');
        },
    },

    computed: {
        public_url() {

            if ( this.$rc.getEnvironment() == 'dev' )
                return 'http://127.0.0.1:8081/app/forms/'+this.$route.params.form_id;

            return 'https://app.redchirp.com/app/forms/'+this.$route.params.form_id;
        },

        has_payment_field()
        {
            return this.profile.fields.some((item) => item.type == 'payment');
        },

        robust_age_gate()
        {
            if ( this.profile == null ) return false;
            if ( this.profile.organization_account == null ) return false;
            return this.profile.organization_account.industry == 'wine';
        },

        age_gate_display_value()
        {
            if ( this.profile == null ) return '';
            if ( this.profile.form == null ) return '';
            if ( this.profile.form.age_gate_min_age_in_years == null ) return '';
            return this.profile.form.age_gate_min_age_in_years.toString();
        },

        organization_default_age_gate_age()
        {
            if ( this.profile == null ) return 21;
            if ( this.profile.organization_account == null ) return 21;
            if ( this.profile.organization_account.features == null ) return 21;
            return this.profile.organization_account.features.default_age_gate_age || 21;
        },

        age_gate_hint()
        {
            let default_age = this.organization_default_age_gate_age;
            return `Organization default is ${default_age} years.`;
        },

        double_opt_in_message_patterns: {
            get() {
                if (!this.profile || !this.profile.form) return [];

                // If there's a custom message, return it as an array with one element
                if (this.profile.form.double_opt_in_message) {
                    return [this.profile.form.double_opt_in_message];
                }

                // If using default message type, return the default pattern
                if (this.profile.form.double_opt_in_message_type === 'default-message' && this.profile.double_opt_in_pattern) {
                    return [this.profile.double_opt_in_pattern];
                }

                return [];
            },
            set(patterns) {
                // This is handled by onUpdateDoubleOptInMessagePatterns
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>